import { render, staticRenderFns } from "./PresentationPackageBoardView.vue?vue&type=template&id=4a8f8a1a&scoped=true&"
import script from "./PresentationPackageBoardView.vue?vue&type=script&lang=js&"
export * from "./PresentationPackageBoardView.vue?vue&type=script&lang=js&"
import style0 from "./PresentationPackageBoardView.vue?vue&type=style&index=0&id=4a8f8a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f8a1a",
  null
  
)

export default component.exports